import React from "react";

const InfosIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#828282"/>
            <path d="M12 14.7773C12.6136 14.7773 13.1112 15.2751 13.1113 15.8887C13.1113 16.5023 12.6136 17 12 17C11.3864 17 10.8887 16.5023 10.8887 15.8887C10.8888 15.2751 11.3864 14.7773 12 14.7773ZM13.1113 13.667H10.8887V7H13.1113V13.667Z"
                fill="#828282" />
        </svg>
    );
}
export default InfosIcon;